import styled, { css } from "styled-components";
import { setPosition, setFlex } from "../variables/utils";
import { BREAKPOINTS, desktop } from "../variables/breakpoints";
import { COLOURS } from "../variables/colours";

export const IntroductionContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ justify: "flex-start", direction: "column" })};
  min-height: 250vh;
  width: 100%;
  ${desktop};
`;

export const HeadingWrapper = styled.div`
  ${setFlex({ justify: "center", align: "flex-start", direction: "column" })}
  width: 100%;
  height: auto;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    max-width: 55vw;
    padding-bottom: 5rem;
  }
`;

export const FixedWrapper = styled.div`
  ${setFlex({ align: "flex-start", justify: "center", direction: "column" })};
`;

export const HeadingContainer = styled.div`
  ${props =>
    props.$sticky && setPosition({ position: "sticky", top: "0", left: "0" })};
  ${props => props.$center && setFlex({ justify: "center", align: "center" })};
  ${props => props.$margin && "margin-top: 400vh"};
  min-height: ${props => (props.$maxHeight ? "200vh" : "100vh")};
  min-width: 100vw;
  height: 100%;
  width: 100%;
`;

export const LandingHeadingContainer = styled.div`
  ${setPosition({ position: "sticky", top: "0", left: "0" })};
  ${setFlex({ justify: "center", align: "center", direction: "column" })};
  min-height: 100vh;
  padding: 2rem;
  width: auto;
`;

export const HeadingStickyContainer = styled.div`
  ${setPosition({ position: "sticky", top: "0", left: "0", zIndex: -1 })};
  ${setFlex({ align: "flex-start", justify: "center", direction: "column" })};
  height: 100vh;
  width: 100%;
  padding: 2rem;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    width: -webkit-fill-available;
    padding: 1.5rem;
  }
`;

export const HeadingImage = styled.img`
  height: 100%;
  margin: 2.5rem;
  max-width: 40vw;
`;

export const LandingContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ justify: "center", direction: "column" })};
  min-height: 300vh;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    ${setFlex({ justify: "flex-start" })};
    width: -webkit-fill-available;
  }
`;

export const TilesContainer = styled.div`
  ${setFlex({ justify: "flex-end" })};
  width: 100%;
`;

export const Headline = styled.h1`
  ${props => props.$color && props.$color};
  text-transform: uppercase;
  font-family: "univers-bold-cond", sans-serif;
  margin: 0;
  padding-bottom: 0.5rem;
  line-height: 2.5rem;
  font-size: 2.5rem;

  @media (max-width: ${BREAKPOINTS.sm}px) {
    line-height: 2rem;
    font-size: 2rem;
  }

  ${props =>
    props.$padding &&
    `
  padding-top: 4rem;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      padding-top: 3rem;
    }
    `}
`;

export const LandingHeadline = styled(Headline)`
  color: ${COLOURS.primary.blue};
  ${props =>
    props.$large
      ? css`
          font-size: 10rem;
          line-height: 10rem;
        `
      : css`
          font-size: 5rem;
          line-height: 5rem;
        `};
`;

export const Paragraph = styled.p`
  ${props => props.$color && props.$color};
  text-transform: uppercase;
  font-family: "univers-bold-cond", sans-serif;
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.375rem;
`;

export const Row = styled.div`
  ${props => setFlex({ justify: props.$justify || "center" })};
  ${props =>
    props.$padding &&
    `
    padding-top: 1rem;
    @media (max-width: ${BREAKPOINTS.sm}px) {
      padding-top: 0.5rem;
    }
    `};
  width: 100%;
`;

export const HeadingRow = styled(Row)`
  padding: 2rem 0;
`;

export const Column = styled.div`
  ${setFlex({})};
  ${props => props.$padding && "padding: 1.5rem 1.5rem 1.5rem 0"};
`;
